module.exports = __webpack_public_path__ + "img/四川天府新区新兴幼儿园.5b743337.jpg";